import { Typography, TypographyProps } from '@mui/material'
import { ReactNode } from 'react'
import { StyledTableCell } from '../invoice-table-body/invoice-table-body'
import {
  listPrimaryTextSx,
  listSecondaryTextSx,
} from 'components/list-table/list-table.styles'

type InvoiceTableCellProps = {
  disabled?: boolean
  value1?: string | ReactNode
  value2?: string
  children?: ReactNode
} & TypographyProps

const InvoiceTableCell = ({
  disabled,
  value1,
  value2,
  minWidth,
  children,
  align,
}: InvoiceTableCellProps) => {
  return (
    <StyledTableCell sx={{ minWidth }} align={align}>
      <Typography
        sx={{
          ...listPrimaryTextSx,
          color: disabled ? 'text.disabled' : 'text.primary',
        }}
      >
        {value1}
      </Typography>
      <Typography
        sx={{
          ...listSecondaryTextSx,
          color: disabled ? 'text.disabled' : 'text.secondary',
        }}
      >
        {value2}
      </Typography>
      {children}
    </StyledTableCell>
  )
}

export default InvoiceTableCell
